export const NavBarHeight: number = 56;
